export default __webpack_public_path__ + "static/media/summer-detail.f104f2a2.svg";